'use client';

import { SiteHeader } from './site-header';

export function NavPreview({ logoSrc, variant }: { logoSrc?: string; variant?: 'default' | 'spa' } = {}) {
  return <SiteHeader logoSrc={logoSrc} variant={variant} />;
}
